import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["amount", "form", "input"]

  connect() {
    this.initialInputValues = this.inputTargets.reduce((values, target) => {
      values[target.getAttribute(`data-${this.identifier}-id-param`)] = target.value
      return values
    }, {})
  }

  submitSelected({ target: { value }, params: { id } }) {
    if (value === this.initialInputValues[id]) {
      this.formTarget.requestSubmit()
    } else {
      this.initialInputValues[id] = value
    }
  }
}
